import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/storage-hub")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("storage");
  },
  staticData: {
    title: "apps.storageHub",
  },
});
